export const _setSapContract = (state, action) => {
  state.sapContract = action.payload;
};

export const _setSapCode = (state, action) => {
  state.sapCode = action.payload;
};

export const _setSapNum = (state, action) => {
  state.sapNum = action.payload;
};

export const _setSapInstitution = (state, action) => {
  state.sapInstitution = action.payload;
};

export const _setSapGender = (state, action) => {
  state.gender = action.payload;
};
